import React from 'react';
import TvarumasList from './tvarumas.component';
// const TvarumasListLazy = React.lazy(() => import('./tvarumas.component'));
export default function Tvarumas(props) {
    return React.createElement(TvarumasList, Object.assign({}, props));
    // return <Suspense fallback={<LoadingBox style={{height:600}} />}> 
    //     <TvarumasListLazy {...props} /> 
    // </Suspense>
}
